import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function OAuthDone() {
  const navigate = useNavigate()

  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage({ connected: true }, '*')
      window.close()
    } else {
      navigate('/dashboard')
    }
  }, [navigate])

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center space-y-3">
        <div className="w-10 h-10 border-2 border-[#e040fb] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-zinc-400 text-sm">Conectando...</p>
      </div>
    </div>
  )
}
